import { useEffect, useState } from "react";
import { Label } from "semantic-ui-react";

export const useForm = (initialState = {}, initialStateErrores = {}) => {
  const [formValues, setFormValues] = useState(initialState);
  const [formValido, setFormValido] = useState(false);
  const [formValuesErrores, setFormValuesErrores] =
    useState(initialStateErrores);

  const reset = (nuevoState = null) => {
    setFormValues(nuevoState ?? initialState);
  };

  const updateState = (datos, index = null) => {
    let nuevoState = formValues;
    datos.map((d) => {
      if (index != null) {
        nuevoState[d.name][index] = d.value;
      } else {
        nuevoState[d.name] = d.value;
      }
    });
    setFormValues({
      ...nuevoState,
    });
  };

  const updateValue = (name, value, index = null) => {
    if (index != null) {
      if (formValues[name][index] == value) return;
      let valores = formValues[name];
      valores[index] = value;
      setFormValues({
        ...formValues,
        [name]: valores,
      });
    } else {
      if (formValues[name] == value) return;
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  const handleInputChange = ({ target }) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value,
    });
  };

  const updateStateErrores = (datos) => {
    let nuevoState = formValuesErrores;
    datos.map((d) => {
      nuevoState[d.name] = { ...nuevoState[d.name], ...d.value };
    });
    setFormValuesErrores({
      ...nuevoState,
    });
  };

  const validarCampos = () => {
    let valido = true;
    let errores = {};
    forCampos: for (const [key, campo] of Object.entries(formValuesErrores)) {
      let error = <></>;
      let tieneError = false;
      forValidaciones: for (let i = 0; i < campo.validaciones.length; i++) {
        const validacion = campo.validaciones[i];

        if ("undefined" != typeof campo.activo && campo.activo === false) {
        } else {
          validacion.posicion = campo.posicion;
          try {
            switch (validacion.tipo) {
              case "vacio":
                if (
                  [null, ""].includes(formValues[key]) ||
                  formValues[key].trim() == ""
                ) {
                  valido = false;
                  error = <>{mensaje(validacion, `Debe ingresar texto`)}</>;
                  tieneError = true;
                  break forValidaciones;
                }
                break;
              case "vacioArchivo":
                console.log(formValues[key].name);
                if (typeof formValues[key].name == "undefined") {
                  valido = false;
                  error = (
                    <>{mensaje(validacion, `Debe ingresar un archivo`)}</>
                  );
                  tieneError = true;
                  break forValidaciones;
                }
                break;
              case "largo":
                if (formValues[key].trim().length < validacion.minimo) {
                  valido = false;
                  error = (
                    <>
                      {mensaje(
                        validacion,
                        `El largo mínimo es de ${validacion.minimo} caracteres`
                      )}
                    </>
                  );
                  tieneError = true;
                  break forValidaciones;
                }
                break;
              case "largoArreglo":
                if (formValues[key].length < validacion.minimo) {
                  valido = false;
                  error = (
                    <>
                      {mensaje(
                        validacion,
                        `Debe seleccionar al menos ${validacion.minimo} opción/es`
                      )}
                    </>
                  );
                  tieneError = true;
                  break forValidaciones;
                }
                break;
              case "positivo":
                if (parseInt(formValues[key]) <= 0) {
                  valido = false;
                  error = (
                    <>
                      {mensaje(validacion, `Debe ingresar un número mayor a 0`)}
                    </>
                  );
                  tieneError = true;
                  break forValidaciones;
                }
                break;
              case "minimo":
                if (
                  typeof validacion.minimo != "undefined" &&
                  parseInt(formValues[key]) < validacion.minimo
                ) {
                  valido = false;
                  error = (
                    <>
                      {mensaje(
                        validacion,
                        `Debe ingresar un número mayor a ${validacion.minimo}`
                      )}
                    </>
                  );
                  tieneError = true;
                  break forValidaciones;
                }
                break;
              case "maximo":
                if (
                  typeof validacion.maximo != "undefined" &&
                  parseInt(formValues[key]) >= validacion.maximo
                ) {
                  valido = false;
                  error = (
                    <>
                      {mensaje(
                        validacion,
                        `Debe ingresar un número menor a ${validacion.maximo}`
                      )}
                    </>
                  );
                  tieneError = true;
                  break forValidaciones;
                }
                break;
              default:
                break;
            }
          } catch (error) {}
        }
      }
      if (formValuesErrores[key].error == error) return;
      const datos = {
        ...campo,
        error: error,
        tieneError: tieneError,
      };
      errores[key] = datos;
    }
    setFormValuesErrores(errores);
    setFormValido(valido);

    function mensaje(validacion, mensajeDefault = "Datos incorrectos") {
      let texto = "";
      if (
        typeof validacion.mensaje != "undefined" &&
        validacion.mensaje != null
      ) {
        texto = validacion.mensaje ?? mensajeDefault;
      } else {
        texto = mensajeDefault;
      }
      switch (validacion.posicion) {
        case "abajo":
          return (
            <span className="d-inline-block mt-1 mb-2 text-danger">
              {texto}
            </span>
          );
          break;
        case "derecha":
          return (
            <span className="d-inline-block mt-1 mb-2 text-danger">
              {texto}
            </span>
          );
          break;
        default:
          return (
            <span className="d-inline-block mt-1 mb-2 text-danger">
              {texto}
            </span>
          );
          break;
      }
    }

    return valido;
  };

  return [
    formValues,
    handleInputChange,
    reset,
    updateValue,
    updateState,
    formValuesErrores,
    validarCampos,
    formValido,
    updateStateErrores,
  ];
};
